import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from "vue";
import TressIconButton from "@/components/TressIconButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressSwitchButton',
  props: {
  state: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  click: (state: boolean) => {
    return true;
  },
},
  setup(__props, { emit }) {

const props = __props;



const internalState = ref<boolean>(props.state);
const onClick = () => {
  internalState.value = !internalState.value;
  emit("click", internalState.value);
};
watch(
  () => props.state,
  (currVal) => {
    internalState.value = currVal;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TressIconButton, { onClick: onClick }, {
    default: _withCtx(() => [
      (!internalState.value)
        ? _renderSlot(_ctx.$slots, "off", { key: 0 })
        : _renderSlot(_ctx.$slots, "on", { key: 1 })
    ]),
    _: 3
  }))
}
}

})